module.exports = __webpack_public_path__ + "f0557cc87730327b7df8f731161af882.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing/example.png
// module id = 1079
// module chunks = 0